import Vue from "vue";
import home from "./components/MainComponent.vue";
import addBusiness from "./components/AddBusinessComponent.vue";
import editBusinessSeo from "./components/business/SearchOptimisation.vue";
import Loading from "./components/Loading.vue";
import CompanyLogo from "./components/business/CompanyLogo.vue";
import CompanyHeader from "./components/business/CompanyHeader.vue";
import editBusinessCategory from "./components/business/Category.vue";
import PaymentForm from "./components/PaymentForm.vue";
import CancelPlan from "./components/CancelPlan.vue";
import Subscribe from "./components/business/Subscribe.vue";
import Products from "./components/business/Products.vue";
import Activities from "./components/business/Activities.vue";
import SendMessage from "./components/SendMessage.vue";
import { store } from "./store/store";
import Vuelidate from "vuelidate";
import TestimonialAdvertise from "./components/testimonials/TestimonialAdvertise.vue";
import lightslider from "./components/lightslider/Lightslider.vue";
import SponsorsSlider from "./components/lightslider/SponsorsSlider.vue";
import SponsorsSliderTemplate from "./components/lightslider/SponsorsSliderTemplate.vue";
import StarRating from "vue-star-rating";

Vue.use(Vuelidate);
import VModal from "vue-js-modal";
import VueToastr from "vue-toastr";
Vue.use(VueToastr, {
    defaultPosition: "toast-bottom-right"
});
Vue.use(VModal);
Vue.use(Loading);
require("./bootstrap");
import $ from "jquery";

window.$ = window.jQuery = $;

Vue.component(
    "edit-business-seo",
    require("./components/business/SearchOptimisation.vue").default
);
Vue.component(
    "edit-business-category",
    require("./components/business/Category.vue").default
);
Vue.component("payment-form", require("./components/PaymentForm.vue").default);
Vue.component("cancel-plan", require("./components/CancelPlan.vue").default);
Vue.component("send-message", require("./components/SendMessage.vue").default);
Vue.component("pagination", require("laravel-vue-pagination"));


const app = new Vue({
    el: "#app",
    store,
    components: {
        home,
        addBusiness,
        editBusinessSeo,
        editBusinessCategory,
        PaymentForm,
        Products,
        Activities,
        CancelPlan,
        Subscribe,
        Loading,
        CompanyLogo,
        CompanyHeader,
        TestimonialAdvertise,
        lightslider,
        SponsorsSlider,
        SponsorsSliderTemplate,
        StarRating,
        SendMessage,

    }
});
